export default class Slider {
  get DEFAULT_OPTIONS() {
    return {
      wrapperClass: 'slides',
      slideClass: 'slide',
      slideActiveClass: 'is-selected',
      speed: 600,
      slidesPerView: 'auto',
      loop: true,
    };
  }

  constructor() {
    this.$elements = [...document.querySelectorAll('[data-slider]')]
    if (!this.$elements) return;
    this.slider;
    this.init();
  }
  
  init() {
    this.create();
  }

  create() {
    this.$elements.forEach(el => {
      this.slider = new Swiper(el, {
        ...this.DEFAULT_OPTIONS,
        loop: el.dataset.sliderLoop ? true : false,
      });
    });
  }
}
